<template>
  <pt-active-sign-notes class="pt-active-sign-notes__page" :name="name" :id="id"></pt-active-sign-notes>
</template>

<script>
import PtActiveSignNotes from 'cps/appointment-application/pt-active-sign-notes/withData'
export default {
  name: 'pt-active-sign-notes__view',
  components: {
    'pt-active-sign-notes': PtActiveSignNotes
  },
  props: {
    name: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: null
    }
  }
}
</script>
